// @ts-nocheck
import React from 'react';
import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';
import Countdown from '../Countdown';

const PremiumCTABar: React.FC<{
  buttonLabel: string;
  onClick(): void;
  banner: {
    message: string;
    alternativeShortMessage: string;
    expirationDate: Date;
  } | null;
}> = ({ buttonLabel = 'Aprovecha esta oferta', onClick, banner }) => {
  return (
    <div className="mx-auto sm:mr-0 sm:ml-auto max-w-280">
      <PrimaryButton
        full
        size="l"
        className="px-16"
        darkMode
        label={buttonLabel}
        onClick={onClick}
      />
      {banner && <Countdown dueDate={banner.expirationDate} />}
    </div>
  );
};

export default PremiumCTABar;
